import React, { PropsWithChildren, useEffect, useState } from 'react';
import { PermissionsGroupsContext } from './PermissionGroupsContext';

interface PermissionsGroupsProviderProps {
    userPermissions: string[];
}

const PermissionsGroupsProvider = ({
    children,
    userPermissions,
}: PropsWithChildren<PermissionsGroupsProviderProps>) => {
    const [permissions, setPermissions] = useState<string[]>([]);

    useEffect(() => {
        setPermissions(userPermissions);
    }, [userPermissions]);

    return (
        <PermissionsGroupsContext.Provider
            value={{
                featurePermissions: permissions,
                isPermissionGroupsLoading: false,
                isPermissionGroupsNetworkError: false,
            }}
        >
            {children}
        </PermissionsGroupsContext.Provider>
    );
};

export default PermissionsGroupsProvider;
